import Game from './game/game.vue'
import Landing from './landing/landing.vue'
import Result from './result/result.vue'

var route = {
  'game': Game,
  'landing': Landing,
  'result': Result
}
export default {
  data () {
    return {
      page: Landing
    }
  },
  methods: {
    changePage (page) {
      this.page = route[page]
    }
  }
}



// WEBPACK FOOTER //
// ./src/component/app.js